import React, { Component } from 'react'
import ApplicationTrackerPV from './ApplicationTrackerPV'
import AuthA from '../../store/actions/AuthA'

import {connect} from 'react-redux'
import axios from 'axios'

class ApplicationTrackerPC extends Component {
  state = {
    appNumber: '',
    applicant:null
  }

  logout = () => { this.props.authFn.logout()}

  handleChange = (e, { name, value }) => this.setState({ [name]: value })

  getApplicant = (appNumber) => {
    const url = process.env.REACT_APP_URL+'/applicants?filter[where][appNumber]='+appNumber;
    axios
      .request({
        method: 'get',
        url: url
      })
      .then(response => {
        if(response.data.length !== 0) {
          this.setState({applicant: response.data[0]})
        } else {
          this.setState({applicant: null})
        }

      })
      .catch(error => {
        console.log(error)
        if (error.response) {
          alert(`${error.response.data.error.message}`);
        } else if (error.request) {
          alert(error.request);
        } else {
          // Something happened in setting up the request that triggered an Error
          alert('Error. Please contact your administrator for assistance.');
        }
      });
  }

  render() {
    return (
      <ApplicationTrackerPV
        applicant={this.state.applicant}
        appNumber={this.state.appNumber}
        auth={this.props.auth}
        getApplicant={this.getApplicant}
        handleChange={this.handleChange}
        logout={this.logout}
      />
    );
  }
}

const mapDispatchToProps = (dispatch) => {
  return {
    authFn: AuthA(dispatch)
  }
}

const mapStateToProps = (state) => {
  return {
    auth: state.AuthR.auth,
    loginErr: state.AuthR.loginErr,
  }
}

export default connect(mapStateToProps, mapDispatchToProps)(ApplicationTrackerPC);
